import React, { useEffect, useState } from "react";
import { API_BASE_URL } from "src/config/apiBase";
import { decryptToken } from "../utils/getToken";

const CrmDocuSignPanel = () => {
  const [config, setConfig] = useState({ provider: "internal", enabled: true });
  const [saving, setSaving] = useState(false);
  const url = API_BASE_URL;
  const token = decryptToken("accessToken") || "";

  useEffect(() => {
    fetch(`${url}/leads/esign-config`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((res) => {
        if (res?.config) setConfig(res.config);
      })
      .catch(() => {});
  }, [url, token]);

  const save = async () => {
    setSaving(true);
    try {
      await fetch(`${url}/leads/esign-config`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ config }),
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="crm-esign-settings">
      <strong>E-sign provider</strong>
      <p className="crm-insights__muted">
        Internal signing links work out of the box. Configure DocuSign env vars on the server for production envelopes.
      </p>
      <label className="crm-automation__row">
        <input
          type="radio"
          checked={config.provider === "internal"}
          onChange={() => setConfig({ ...config, provider: "internal" })}
        />
        <span>Internal signing page (default)</span>
      </label>
      <label className="crm-automation__row">
        <input
          type="radio"
          checked={config.provider === "docusign"}
          onChange={() => setConfig({ ...config, provider: "docusign" })}
        />
        <span>DocuSign (requires DOCUSIGN_* env on backend)</span>
      </label>
      <button type="button" className="crm-platform__save" onClick={save} disabled={saving}>
        {saving ? "Saving…" : "Save e-sign settings"}
      </button>
    </div>
  );
};

export default CrmDocuSignPanel;
